import { gql } from "@apollo/client";

export const RECORD_WRONG_ANSWERS_BATCH = gql`
  mutation RecordWrongAnswersBatch($inputs: [RecordWrongAnswerInput!]!) {
    recordWrongAnswersBatch(inputs: $inputs) {
      success
      successCount
      failedCount
    }
  }
`;

export const RECORD_CORRECT_ANSWER = gql`
  mutation RecordCorrectAnswer($inputs: RecordCorrectAnswerInput!) {
    recordCorrectAnswer(inputs: $inputs) {
      success
    }
  }
`;

export const RECORD_CORRECT_ANSWERS_BATCH = gql`
  mutation RecordCorrectAnswersBatch($inputs: [RecordCorrectAnswerInput!]!) {
    recordCorrectAnswersBatch(inputs: $inputs) {
      success
      successCount
      failedCount
    }
  }
`;

export const GET_RANDOM_WRONG_ITEMS = gql`
  query GetRandomWrongItems($inputs: GetRandomWrongItemsInput!) {
    getRandomWrongItems(inputs: $inputs) {
      success
      count
      items {
        correctText
        studentText
        itemType
        questionStyleType
        pageId
        timesWrong
        timesCorrect
      }
    }
  }
`;

export const GET_ALL_WRONG_ITEMS = gql`
  query GetAllWrongItems($inputs: GetAllWrongItemsInput!) {
    getAllWrongItems(inputs: $inputs) {
      success
      count
      items {
        id
        correctText
        questionStyle
        questionStyleType
        pageId
        sectionId
        unitTitle
        unitId
        bookTitle
        bookId
        bookLevel
        booksetTitle
        booksetId
        booktypeTitle
        booktypeId
        timesCorrect
        isMastered
        lastAttemptedAt
      }
    }
  }
`;

export const CLEANUP_WRONG_ANSWER_DUPLICATES = gql`
  mutation CleanupWrongAnswerDuplicates($userId: ID) {
    cleanupWrongAnswerDuplicates(userId: $userId) {
      success
      mergedGroups
      archivedItems
    }
  }
`;
